module.exports = __webpack_public_path__ + "img/1490910557.5d6c3ce0.jpg";